export const DEAL_STATUS_APPROVED = "Approved";
export const DEAL_STATUS_PENDING = "Pending";
export const DEAL_STATUS_DECLINED = "Declined";
export const DEAL_STATUS_REQUESTED = "Requested";
export const DEAL_STATUS_DRAFT = "Draft";
export const DEAL_STATUS_SUBMITTED = "Submitted";
export const DEAL_STATUS_CLOSED = "Closed";
